export const logout = () => {
  document.location.href = OAUTH_LOGOUT_URL;
};

export const generateLoginUrl = (oauthState) => {
  const scopeAndResponseType = "scope=internal&response_type=token";
  const result = `${OAUTH_BASE_URL}?`;
  return result.concat(`client_id=${OAUTH_CLIENT_ID}`)
    .concat(`&${scopeAndResponseType}`)
    .concat(`&state=${oauthState}`)
    .concat(`&redirect_uri=${OAUTH_LANDING_PAGE}`);
};

export const parseOauthCallback = (hash) => {
  const token = parseToken(hash);
  const state = parseState(hash);
  return { token, state };
};

const parseToken = (hash) => {
  const tokenRegex = /access_token=([^&]+)/;
  const tokenResult = hash.match(tokenRegex);
  if (tokenResult === null || tokenResult === undefined) {
    return null;
  }
  return tokenResult[1];
};

const parseState = (hash) => {
  const stateRegex = /state=([^&]+)/;
  const stateResult = hash.match(stateRegex);
  if (stateResult === null || stateResult === undefined) {
    return null;
  }
  return stateResult[1];
};




// WEBPACK FOOTER //
// ./src/js/utils/oauth.js